import { createContext } from "react";
export const FocusableTreeContext = createContext({
    addFocusableToMap: () => { },
    removeFocusableFromMap: () => { },
    focusPath: [],
    parentPath: [],
    parentFocusableNode: {
        focusKey: "",
        getParent: () => undefined,
        getBoundingBox: () => ({
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
        }),
        getChildren: () => new Map(),
        getPreferredChild: () => undefined,
        lock: [],
    },
    registerFocusable: () => { },
    unregisterFocusable: () => { },
    dispatchOnFocus: () => { },
    dispatchOnBlur: () => { },
});
